import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Caller } from '../../_models/caller';

@Component({
  selector: 'app-dunzo-webhook',
  templateUrl: './dunzo-webhook.component.html',
  styleUrls: ['./dunzo-webhook.component.scss'],
})
export class DunzoWebhookComponent implements OnInit {
  id: any;
  comments: any;

  constructor(private alertService: AlertService, private g: Globals, private http: HttpClient, private route: ActivatedRoute, private router: Router, public caller: Caller) {
    this.id = this.route.snapshot.params['id'];
    this.comments = this.route.snapshot.params['comments'];
    this.reloadFunction();
  }

  ngOnInit() {
  }

  reloadFunction() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/web-hook', {
      "comments": this.comments,
      "id": this.id
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.caller.parent = "SUCCESS";
          this.router.navigate(['/access/info']);
        }
        else {
          this.alertService.error('Error', data['message']);
          this.caller.parent = "FAIL";
          this.router.navigate(['/access/info']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.caller.parent = "FAIL";
          this.router.navigate(['/access/info']);
        });
  }
}
